export default {"src":"/_next/static/media/error.fbf4f1d4.svg","height":80,"width":72,"blurWidth":0,"blurHeight":0};